import { useState } from 'react';
import { ArrowsPointingOutIcon } from '@heroicons/react/24/outline';
import Modal from '../modals/Modal';
import { FieldError } from './FormField';
import { IconTooltip } from './TooltipCard';

function ExpandableTextarea({
  id,
  name,
  value,
  onChange,
  required = false,
  autoFocus = false,
  error,
  title,
  className = 'h-[150px]',
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div className="relative">
        <textarea
          id={id}
          name={name}
          required={required}
          autoFocus={autoFocus}
          value={value}
          onChange={onChange}
          className={`textarea textarea-bordered text-sm w-full block resize-none pb-6 no-scrollbar focus:outline-none ${className} ${error ? 'textarea-error' : ''}`}
        />
        <div className="absolute bottom-1.5 right-1.5">
          <IconTooltip label="Expand" position="top-right">
            <button
              type="button"
              className="p-0.5 rounded text-slate-300 hover:text-slate-500 transition focus:outline-none"
              onClick={() => setIsExpanded(true)}
              aria-label="Expand"
            >
              <ArrowsPointingOutIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </IconTooltip>
        </div>
      </div>
      <FieldError>{error}</FieldError>

      <Modal
        isOpen={isExpanded}
        onClose={() => setIsExpanded(false)}
        title={title}
        maxWidth="max-w-3xl"
        zIndex="z-[60]"
      >
        <textarea
          autoFocus
          className="textarea textarea-bordered text-sm w-full h-[60vh] resize-none focus:outline-none"
          value={value}
          onChange={onChange}
        />
        <div className="flex justify-end gap-2 mt-2">
          <button
            type="button"
            className="btn btn-primary btn-sm w-24 focus:outline-none"
            onClick={() => setIsExpanded(false)}
          >
            Done
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ExpandableTextarea;
